<template>
  <div class="contract">
    <div class="mainHead" v-show="!showHeader">
      <div class="head">
        <div class="headLeft" @click="toHome()">
          <!-- <img src="./../assets/headlogo.png" alt="" /> -->
          <div>区块链浏览器</div>
        </div>
        <div class="headRight">
          <el-dropdown>
            <div style="color: black; height: 35px; line-height: 40px">
              {{ type }}<i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in datalist"
                :key="index"
                @click.native="dropdowns(item)"
                >{{ item }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-input
            :placeholder="placeholder"
            v-model="inputValue"
            class="elInput"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search()"
              style="background-color: #dbdeed; width: 0px"
            ></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      style="width: 1200px; margin: 0 auto; margin-top: 50px"
    >
      <el-table-column
        prop="user_id"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="用户"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="token_name"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="存证名称"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.token_name.replace(/中钞/g, "融权") }}</span>
        </template>
      </el-table-column>
      <!--                    <el-table-column-->
      <!--                            prop="channelname"-->
      <!--                            header-align="center"-->
      <!--                            align="center"-->
      <!--                            label="通道号"-->
      <!--                            width="180">-->
      <!--                    </el-table-column>-->
      <el-table-column
        prop="chain_tx_id"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        label="交易哈希"
      >
        <!--                <template slot-scope="scope">-->
        <!--                    <el-button type="text" @click="getTransaction(scope.row.chain_tx_id,scope.row.type)">{{scope.row.chain_tx_id}}</el-button>-->
        <!--                </template>-->
      </el-table-column>
      <!--            <el-table-column-->
      <!--                    prop="type"-->
      <!--                    header-align="center"-->
      <!--                    align="center"-->
      <!--                    label="类型">-->
      <!--                <template slot-scope="scope">-->
      <!--                    <span v-if="scope.row.type == '1'">铸造</span>-->
      <!--                    <span v-if="scope.row.type == '2'">交易</span>-->
      <!--                </template>-->
      <!--            </el-table-column>-->
      <el-table-column
        header-align="center"
        align="center"
        prop="contract"
        :show-overflow-tooltip="true"
        label="合约名称"
      >
        <!--                <template slot-scope="scope">-->
        <!--                    <span>TDAPFXE7EPL4W6EMIRWV2FDLQ4XR4TZF</span>-->
        <!--                </template>-->
      </el-table-column>
      <el-table-column
        prop="created_time"
        header-align="center"
        align="center"
        label="时间"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.created_time | dateFormate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_time"
        header-align="center"
        align="center"
        label="销毁状态"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.burn === false">未销毁</span>
          <span v-if="scope.row.burn === true">已销毁</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      :layout="layout"
      :pager-count="pagerCount"
      :small="small"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "contract-address",
  data() {
    return {
      list: [],
      total: 0,
      limit: 10,
      page: 1,
      layout: "total, sizes, prev, pager, next, jumper",
      pagerCount: 0,
      small: false,
      //头部
      inputValue: "",
      datalist: ["存证编号", "交易哈希", "用户地址", "合约地址"],
      placeholder: "",
      type: "",
      showHeader: true,
    };
  },
  created() {
    this.getPlaceholder();
    this.getContract();
    this.getEquipment();
  },
  methods: {
    toHome() {
      this.$router.push({
        name: "home",
      });
    },
    getPlaceholder() {
      this.placeholder = "请输入合约地址";
      this.type = this.datalist[3];
    },
    dropdowns(item) {
      this.placeholder = "请输入" + item;
      this.type = item;
    },
    search() {
      if (this.inputValue) {
        console.log(this.type);
        if (this.type == "交易哈希") {
          if (this.inputValue) {
            this.$router.push({
              path: "/hash-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "存证编号") {
          if (this.inputValue) {
            this.$router.push({
              path: "/evidence-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "合约地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/contract-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "用户地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/user-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        }
      } else if (!this.inputValue) {
        // console.log(this.type)
        this.$message({
          message: "请输入" + this.type,
          type: "warning",
        });
      }
    },
    getEquipment() {
      let equ = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (equ) {
        this.showHeader = false;
        this.layout = "total, prev, pager, next";
        this.pagerCount = 5;
        this.small = true;
      } else {
        this.showHeader = true;
        this.layout = "total, sizes, prev, pager, next, jumper";
        this.pagerCount = 7;
        this.small = false;
      }
    },
    getContract() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/contractinfouserlist", {
          params: {
            contract: this.$route.query.id,
            pageIndex: this.page,
            pageSize: this.limit,
          },
        })
        .then((res) => {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
        });
    },
    sizeChangeHandle(val) {
      this.limit = val;
      this.page = 1;
      this.getContract();
    },
    currentChangeHandle(val) {
      this.page = val;
      this.getContract();
    },
  },
};
</script>

<style scoped lang="scss">
.mainHead {
  margin-top: 0px;
  height: 70px;
  background-color: #fff;
  width: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  .head {
    display: flex;
    justify-content: space-between;
    // margin: 0 auto;
    // max-width: 1200px;
    .headLeft {
      cursor: pointer;
      display: flex;
      margin-top: 20px;
      img {
        width: 30px;
        height: 30px;
      }
      div {
        width: 100px;
        font-size: 16px;
        font-weight: bolder;
        // margin-left: 10px;
        line-height: 30px;
        font-family: "黑体";
        /*color: #1270b9;*/
        color: rgb(44, 37, 37);
      }
    }
    .headRight {
      display: flex;
      margin: 15px 0px 0px 0px;
      /deep/ .el-input-group > .el-input__inner {
        background-color: #f1f1f1;
      }
      /deep/ .el-input__inner {
        border-color: transparent;
      }
      .elInput {
        width: 60%;
      }
    }
  }
}
</style>